/* eslint import/first: 0 */
/* eslint import/extensions: 0 */
/* eslint import/no-unresolved: 0 */
import jQuery from 'jquery';
import 'jquery.cookie';
import '../css/main.scss';
import 'core-js/fn/object/values';
import 'core-js/fn/object/entries';
import 'core-js/fn/array/includes';
import 'core-js/fn/string/includes';
import 'url-search-params-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import { cleanLegacy } from 'rp-cookie';
import rpGuiGuide from 'rp-gui-guide';
import initNavigationPrefs from 'rp-url-navigation-prefs';
import Root from './components/Root';
import configureStore from './store/configureStore';
import * as SegmentIO from 'rp-analytics';
import analyticsPage from './analyticsPage';
import { loadUserInfoRequest } from './actions/userInfo';
/**
 * @NOTE: Have to import something from 'rp-navigation' in order to execute embedded init logic!!!
 */
import { authReady } from 'rp-navigation'; /* eslint-disable-line no-unused-vars */

jQuery.cookie('to_force_inclusion_in_code');

window.SegmentIO = SegmentIO;

const root = document.getElementById('root');
const store = configureStore();

store.dispatch(loadUserInfoRequest());

const render = (Component) => {
  ReactDOM.render(
    <AppContainer>
      <Component store={store} />
    </AppContainer>,
    root,
  );
};

render(Root);

if (module.hot) {
  module.hot.accept('./components/Root', () => {
    render(Root);
  });
}

analyticsPage();
cleanLegacy();
rpGuiGuide({
  svg: { polyfill: true },
});
initNavigationPrefs();
